export const INFO_GENERIC_RULES_WHEN = {
  after_patient_identification: 'after_patient_identification',
  after_choosing_service_type: 'after_choosing_service_type',
  after_product_selection: 'after_product_selection'
};

export const INFO_GENERIC_RULES_ACTION = {
  FIND_ANOTHER_DOCTOR: 'FIND_ANOTHER_DOCTOR',
  CHANGE_PRODUCT: 'CHANGE_PRODUCT',
  TO_SERVICE_TYPE: 'TO_SERVICE_TYPE',
  CLOSE_MODAL: 'CLOSE_MODAL',
  CLOSE: 'CLOSE',
  OPEN_MODAL_CONDITION: 'OPEN_MODAL_CONDITION',
  OPEN_WHATSAPP: 'OPEN_WHATSAPP',
  FIND_SLOTS_BY_UNIT_SPECIALIST: 'FIND_SLOTS_BY_UNIT_SPECIALIST',
  FIND_SLOTS_WITHOUT_RESOURCEID: 'FIND_SLOTS_WITHOUT_RESOURCEID',
  MAKE_A_CALL: 'MAKE_A_CALL'
};

export const INFO_GENERIC_RULES_CONDITION = {
  professionals_without_schedule_available_first_consult: 'professionals_without_schedule_available_first_consult',
  professionals_without_schedule_available_return: 'professionals_without_schedule_available_return',
  professional_without_schedule_available: 'professional_without_schedule_available',
  is_first_appointment: 'is_first_appointment',
  always: 'always',
  schedule_consult: 'schedule_consult',
  diu_professional_without_schedule_available: 'diu_professional_without_schedule_available',
  unavailable_slots: 'unavailable_slots',
  doctors_unavailable: 'doctors_unavailable'
};

export enum PAYMENT_TYPE {
  PARTICULAR = 'PARTICULAR',
  B2B = 'B2B',
  HELTH_INSURANCE = 'HELTH_INSURANCE'
}

export enum SchedulesTypes {
  APPOINTMENT = 'APPOINTMENT',
  CONSULTATION = 'CONSULTATION',
  EXAM = 'EXAM',
  IMMUNIZATION = 'IMMUNIZATION'
}
